<template>
    <div class="form-group" :class="computedClasses">
        <input
            :id="`form-control-rangedatepicker-${id}`"
            ref="materialInput"
            type="text"
            class="form-control form-control-rangedatepicker"
            :class="inputClasses"
            :name="name"
            :placeholder="placeholder"
            :value="rangeText"

            :readonly="true"
            :disabled="disabled"
            :autocomplete="autocomplete"

            :required="required"

            @input="handleModelInput(true)"
            @focus="handleFocus(true)"
            @blur="handleFocus(false)"
        >
        <label class="material-label" :class="activeClass" :for="`form-control-rangedatepicker-${id}`">
            <slot></slot>
        </label>
        <small v-if="error" class="invalid-feedback">{{ error }}</small>
    </div>
</template>

<script>
    export default {
        name: 'material-daterangepicker',
        data () {
          return {
            id: null,
            valueCopy: {
                startDate: null,
                endDate: null,
            },
            start: null,
            end: null,
            locale: {},
            focus: false,
            valid: true,
            open: false,
            drp: null,
            // jQuery DOM
            elem: null,
          }
        },
        computed: {
          computedErrors () {
            return typeof this.errorMessages === 'string'
              ? [this.errorMessages] : this.errorMessages
          },
          computedClasses () {
            return {
              'material--active': this.focus,
              'material--disabled': this.disabled,
              'material--has-errors': Boolean(
                !this.valid ||
                (this.errorMessages && this.errorMessages.length)),
              'material--raised': Boolean(
                this.focus ||
                !this.isClear || // has value
                (this.placeholder && this.isClear)) // has placeholder
            }
          },
          activeClass () {
            let flag = Boolean(
                this.focus ||
                this.isOpen ||
                !this.isClear || // has value
                (this.placeholder && this.isClear));
            return {
              'active': flag,
              'city-active': flag, //Existem problemas quando se abre / fecha o popup...esta class força a manter ativa pois o javascript remove a class "active" e deixo de conseguir controlar as coisas através do vuejs
            }
          },
          startText () {
            if (this.start === null)
                return ''
            return moment(this.start).format(this.locale.format);
          },
          endText () {
            if (this.singleDatePicker) return this.start;
            if (this.end === null)
                return ''
            return moment(this.end).format(this.locale.format);
          },
          rangeText () {
            let range = this.startText;
            if (!this.singleDatePicker) {
              range += this.endText ? this.locale.separator + this.endText : '';
            }
            return range;
          },
          isOpen () {
            return this.open;
          },
          isClear () {
            return !this.valueCopy.startDate || !this.valueCopy.endDate;
          },
          isDirty () {
            let origStart = new Date(this.valueCopy.startDate)
            let origEnd = new Date(this.valueCopy.endDate)
            return !this.isClear && (this.start.getTime() !== origStart.getTime() || this.end.getTime() !== origEnd.getTime())
          }

        },
        beforeMount () {
            this.id = this._uid;
            // startDate:
            // (Date or string) The beginning date of the initially selected date range. If you provide a string, it must match the date format string set in your locale setting.
            // endDate:
            // (Date or string) The end date of the initially selected date range.
            this.start = this.value && this.value.startDate ? (typeof this.value.startDate === 'string' || this.value.startDate instanceof String ? new Date(this.value.startDate) : this.value.startDate) : null;
            if (this.singleDatePicker) {
                // ignore endDate for singleDatePicker
                this.end = this.start
            } else {
                this.end = this.value && this.value.endDate ? (typeof this.value.endDate === 'string' || this.value.endDate instanceof String ? new Date(this.value.endDate) : this.value.endDate) : null;
            }
            this.locale = this.configLocaleData({...this.localeData});

            // Here we are following the Vue2 convention on custom v-model:
            // https://github.com/vuejs/vue/issues/2873#issuecomment-223759341
            this.copyValue(this.value)
        },
        mounted() {
            this.createElementDaterangepicker();
        },
        methods: {
            handleModelInput (event) {
                // this.$emit('input', event.target.value, event)
                this.handleValidation()
            },
            handleFocus (focused) {
                this.focus = focused
            },
            handleValidation () {
                this.valid = this.$el ? this.$el.querySelector('.form-control').validity.valid : this.valid
            },
            copyValue (value) {
                this.valueCopy = value ? value : {startDate: null, endDate: null};
                this.handleValidation()
            },
            createElementDaterangepicker() {
                // Return early if date-picker is already loaded
                if (!this.drp && !this.disabled){
                    // this.$nextTick(function(){
                    // Handle wrapped input
                    // this.elem = $(this.$el);
                    this.elem = $(this.$refs.materialInput);

                    // Init date-picker
                    this.elem.daterangepicker({
                        autoApply: this.autoApply,
                        minDate: this.minDate,
                        maxDate: this.maxDate,
                        showWeekNumbers: this.showWeekNumbers,
                        linkedCalendars: this.linkedCalendars,
                        locale: this.locale,
                        singleDatePicker: this.singleDatePicker,
                        showDropdowns: this.showDropdowns,
                        timePicker: this.timePicker,
                        timePickerIncrement: this.timePickerIncrement,
                        timePicker24Hour: this.timePicker24Hour,
                        timePickerSeconds: this.timePickerSeconds,
                        ranges: this.singleDatePicker ? false : this.ranges,
                        showCustomRangeLabel: this.showCustomRangeLabel,
                        alwaysShowCalendars: this.alwaysShowCalendars,
                        opens: this.opens,
                        autoUpdateInput: this.autoUpdateInput,
                    }, this.handleDateRange);

                    // Store data control
                    this.drp = this.elem.data('daterangepicker');

                    // Register events
                    this.registerEvents();

                    if(this.start){
                        this.drp.setStartDate(this.start);
                    }
                    if(this.end){
                        this.drp.setEndDate(this.end);
                    }

                    this.handleFocus(false);

                    // });
                }
            },
            /**
             * Update v-model upon change triggered by date-picker itself
             *
             * @param start, end, label
             */
            handleDateRange(start, end, label) {
                this.start = start ? start.toDate() : null;
                this.end = end ? end.toDate() : null;
                this.$emit(
                  'input',
                  {
                    startDate: start ? (this.databaseDateFormat ? start.format(this.databaseDateFormat) : start.toDate()) : null,
                    endDate: end ? (this.databaseDateFormat ? end.format(this.databaseDateFormat) : end.toDate()) : null,
                  },
                  label
                );
                this.handleValidation()
            },
            registerEvents() {
                this.elem.on('apply.daterangepicker', (e, picker) => {

                });
                this.elem.on('cancel.daterangepicker', (e, picker) => {
                    if(this.clearButton){
                        this.handleDateRange(null, null, null);
                    }
                });
                this.elem.on('show.daterangepicker showCalendar.daterangepicker', (e, picker) => {
                    this.open = true;
                });
                this.elem.on('hide.daterangepicker hideCalendar.daterangepicker', (e, picker) => {
                    this.open = false;
                });
            },
            configLocaleData(options) {
                let default_locale = {
                    direction: 'ltr',
                    format: this.dateFormat, //'DD/MM/YYYY',
                    separator: this.separator,
                    applyLabel: 'Apply',
                    cancelLabel: this.clearButton ? 'Clear' : 'Cancel',
                    weekLabel: 'W',
                    customRangeLabel: 'Custom Range',
                    daysOfWeek: moment.weekdaysMin(),
                    monthNames: moment.monthsShort(),
                    firstDay: moment.localeData().firstDayOfWeek(),
                };
                return {...default_locale, ...options }
            },
            externalSetStartDate(start) {
                if (this.drp){
                    start = typeof start === 'string' || start instanceof String ? new Date(start) : start;
                    if(start){
                      if(!this.valueCopy.startDate){
                        this.drp.setStartDate(start);
                        if(this.singleDatePicker){
                          this.drp.setEndDate(start);
                        }
                        if(this.elem) {
                          this.elem.val("");
                        }
                      }
                    }
                }
            },
        },
        beforeDestroy() {
            if (this.drp) {
                this.drp = null;
                this.elem = null;
            }
        },
        watch: {
          value: {
            deep: true,
            handler: function(newValue, oldValue) {
				this.copyValue(newValue);
				this.start = this.value?.startDate ? (typeof this.value.startDate === 'string' || this.value.startDate instanceof String ? new Date(this.value.startDate) : this.value.startDate) : null;

				if (this.singleDatePicker) {
					this.end = this.start;
				} else {
					this.end = this.value?.endDate ? (typeof this.value.endDate === 'string' || this.value.endDate instanceof String ? new Date(this.value.endDate) : this.value.endDate) : null;
				}
				if(this.drp) {
					if(this.start) {
						this.drp.setStartDate(this.start);
					}
					if(this.end) {
						this.drp.setEndDate(this.end);
					}
				}
            }
          },
          singleDatePicker (newValue) {
            if (this.drp && !this.disabled){
              this.drp.remove();
              this.drp = null;
              this.createElementDaterangepicker();
            }
          },
          disabled (newValue) {
            if(this.drp) {
              this.drp.remove();
              this.drp = null;
            }
            this.createElementDaterangepicker();
          },
        },
        props: {
          // id: {
          //   type: String,
          //   default: null
          // },
          name: {
            type: String,
            default: null
          },
          /**
           * This is the v-model prop which the component uses. This should be an object containing startDate and endDate props.
           * Each of the props should be a string which can be parsed by Date, or preferably a Date Object.
           * @default {
           * startDate: null,
           * endDate: null
           * }
           */
          value: {
            type: [Object],
            required: false,
            default: () => {
              return {
                startDate: null,
                endDate: null,
              }
            },
          },
          placeholder: {
            type: String,
            default: null
          },
          disabled: {
            type: Boolean,
            default: false
          },
          autocomplete: {
            type: String,
            default: 'off',
          },
          required: {
            type: Boolean,
            default: false
          },
          errorMessages: {
            type: [Array, String],
            default: null
          },
          inputClasses: {
            type: [Array, Object, String],
            default: null
          },
          error: {
            type: String,
            default: null
          },
          config: {
            type: Object,
            default: () => ({})
          },
          minDate: {
            type: [String, Date],
            default () {
              return undefined
            }
          },
          maxDate: {
            type: [String, Date],
            default () {
              return undefined
            }
          },
          /**
           * Show the week numbers on the left side of the calendar
           */
          showWeekNumbers: {
            type: Boolean,
            default: false,
          },
          /**
           * Each calendar has separate navigation when this is false
           */
          linkedCalendars: {
            type: Boolean,
            default: true,
          },
          /**
           * Auto apply selected range. If false you need to click an apply button
           */
          autoApply: {
            type: Boolean,
            default: false,
          },
          dateFormat: {
            type: String,
            default: 'DD/MM/YYYY', //'YYYY-MM-DD HH:mm:ss',
          },
          databaseDateFormat: {
            type: String,
            default: null,
          },
          /**
           * Object containing locale data used by the picker.
           */
          localeData: {
            type: Object,
            default () {
                return {}
            },
          },
          /**
           * Allows you to select only one date (instead of range). This will hide the ranges with different start/end
           */
          singleDatePicker: {
            type: Boolean,
            default: false,
          },
          /**
           * Show the dropdowns for month and year selection above the calendars
           */
          showDropdowns: {
            type: Boolean,
            default: true,
          },
          /**
           * Show the dropdowns for time (hour/minute) selection below the calendars
           */
          timePicker: {
            type: Boolean,
            default: false,
          },
          /**
           * Determines the increment of minutes in the minute dropdown
           */
          timePickerIncrement: {
            type: Number,
            default: 5,
          },
          /**
           * Use 24h format for the time
           */
          timePicker24Hour: {
            type: Boolean,
            default: true,
          },
          /**
           * Allows you to select seconds except hour/minute
           */
          timePickerSeconds: {
            type: Boolean,
            default: false,
          },
          /**
           * You can set this to false in order to hide the ranges selection. Otherwise it is an object with key/value. See below
           * @default *see below
           */
          ranges: {
            type: [Object, Boolean],
            default () {
              let today = new Date()
              today.setHours(0, 0, 0, 0)
              let yesterday = new Date()
              yesterday.setDate(today.getDate() - 1)
              yesterday.setHours(0, 0, 0, 0);
              let thisMonthStart = new Date(today.getFullYear(), today.getMonth(), 1);
              let thisMonthEnd = new Date(today.getFullYear(), today.getMonth() + 1, 0);
              return {
                'Today': [today, today],
                'Yesterday': [yesterday, yesterday],
                'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                'This month': [thisMonthStart, thisMonthEnd],
                'This year': [new Date(today.getFullYear(), 0, 1), new Date(today.getFullYear(), 11, 31)],
                'Last month': [new Date(today.getFullYear(), today.getMonth() - 1, 1), new Date(today.getFullYear(), today.getMonth(), 0)],
              }
            }
          },
          showCustomRangeLabel: {
            type: Boolean,
            default: false,
          },
          /**
           * If set to false and one of the predefined ranges is selected then calendars are hidden.
           * If no range is selected or you have clicked the "Custom ranges" then the calendars are shown.
           */
          alwaysShowCalendars: {
            type: Boolean,
            default: true
          },
          /**
           * which way the picker opens - "center", "left", "right" or "inline"
           */
          opens: {
            type: String,
            default: 'center',
            validator: value => {
                return ['left', 'center', 'right', 'inline'].indexOf(value) !== -1;
            }
          },
          /**
           *  Indicates whether the date range picker should automatically update the value of the <input> element it's attached to at initialization and when the selected dates change.
           */
          autoUpdateInput: {
            type: Boolean,
            default: true
          },
          showTime: {
            type: Boolean,
            default: false
          },
          clearButton: {
            type: Boolean,
            default: false
          },
          separator: {
            type: String,
            default: ' - '
          }
        }
    }
</script>

<style lang="scss" scoped="">

</style>
